import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import ContractToSellStep1 from './ContractToSellStep1';
import ContractToSellStep2 from './ContractToSellStep2';
import ContractToSellStep3 from './ContractToSellStep3';
import ContractToSellStep4 from './ContractToSellStep4';
import ContractToSellStep5 from './ContractToSellStep5';
import ContractToSellStep6 from './ContractToSellStep6';
import ContractToSellStep7 from './ContractToSellStep7';
import Ty from './Ty';

const ContractToSell = (props)=>{
	let basePath = "/contracts/real-estate/contract-to-sell";

	const meta = {
		title: "Contract to Sell",
		description: "A Contract to Sell is a written agreement whereby the seller binds himself to transfer, assign and sell all his rights and interest over a real property to the buyer subject to the full payment of the purchase price. This is the document usually executed by the parties when the buyer intends to purchase the real property in installment basis. In this regard, the schedule of payment is contained in this type of document. Upon the full payment of the contract price, the parties are then bound to execute a Deed of Absolute Sale. This is the document that will transfer, assign and sell all the rights and interest of the seller over the subject real property to the buyer."
	}

	return (
		<div className="page page-inner page-contract">
			<Meta {...meta}/>
			<div className="container-fluid">
				<div className="p-0">
					<div className="page-content py-3">

						<Switch>
							<Route path={basePath+"/1"} component={ContractToSellStep1} />
							<Route path={basePath+"/2"} component={ContractToSellStep2} />
							<Route path={basePath+"/3"} component={ContractToSellStep3} />
							<Route path={basePath+"/4"} component={ContractToSellStep4} />
							<Route path={basePath+"/5"} component={ContractToSellStep5} />
							<Route path={basePath+"/6"} component={ContractToSellStep6} />
							<Route path={basePath+"/7"} component={ContractToSellStep7} />
							<Route path={basePath+"/ty"} component={Ty} />
							<Route component={DefaultView} />
						</Switch>

					</div>
				</div>
			</div>
		</div>
	);
}

export default ContractToSell;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/contract-to-sell/ContractToSell.js